// extracted by mini-css-extract-plugin
export default {"container":"profile-card_container__o8eyN"};